'use strict';

var accordion = require('../../../../../../../../../../_virtual/accordion.cjs');

(function (exports) {

	exports.ACCORDION_SIZES = void 0;
	(function(ACCORDION_SIZES) {
	    ACCORDION_SIZES["small"] = "small";
	    ACCORDION_SIZES["medium"] = "medium";
	    ACCORDION_SIZES["large"] = "large";
	})(exports.ACCORDION_SIZES || (exports.ACCORDION_SIZES = {}));
	
} (accordion.__exports));
//# sourceMappingURL=accordion.cjs.map
